import { Component, OnInit, Input } from '@angular/core';
import { PatentService } from '../patent.service'

@Component({
  selector: 'app-tag-patent-menu',
  templateUrl: './tag-patent-menu.component.html',
  styleUrls: ['./tag-patent-menu.component.css']
})
export class TagPatentMenuComponent implements OnInit {
  @Input() label: string
  @Input() value: string
  @Input() tp: string


  constructor(
    private ps: PatentService
  ) { }

  ngOnInit() {
  }

  switch(event) {
      this.ps.setFilter(this.tp, this.value)
  }

  get isSelected() {
    return this.ps.isSelectedFilter(this.tp, this.value)
  }

}



// WEBPACK FOOTER //
// ./src/app/tag-patent-menu/tag-patent-menu.component.ts